<template>
  <div>
    <van-search v-model="value" show-action label="企业名称" placeholder="请输入搜索关键词" style="box-shadow: 0px 1px 4px #F0F0F0;" @search="onSearch">
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-row style="text-align: center;height: 40px;line-height: 40px; font-size: 15px;box-shadow: 0px 1px 4px #F0F0F0;">
      <van-col span="6">企业名称</van-col>
      <van-col span="6">地址</van-col>
      <van-col span="6">地区</van-col>
      <van-col span="6">
        <van-button type="warning" plain hairline size="mini" @click="ins()">新增数据</van-button>

      </van-col>
    </van-row>
    <van-row v-for="list in data" :key="list.id" style=" text-align: center;height:0px ; padding-top: 5px; padding-bottom: 30px; box-shadow: 0px 1px 4px #F0F0F0;">
      <van-col span="6" style="box-shadow: 0px 1px 4px #A5BCFF;" class="x" @click="put(list.id)">{{ list.client_name | ellipsis }}</van-col>
      <van-col span="6" style="box-shadow: 0px 1px 4px #ffaa00;" class="x" @click="addr(list.address,list.client_name)">{{ list.address | ellipsis }}</van-col>
      <van-col span="6" style="box-shadow: 0px 1px 4px #A5BCFF;" class="x">{{ list.area | ellipsis }}</van-col>
      <van-col span="6" style="box-shadow: 0px 1px 4px #FF976A;">
        <van-button size="mini" plain hairline style="width:100%; height: 25.6px;line-height: 25.6px;" type="info" @click="put(list.id)">修改</van-button>
        <!-- <van-button type="warning" size="mini" @click="ins()">新增</van-button> -->
      </van-col>
    </van-row>
    <van-popup v-model="show" style="height: 50%;width: 90%; background-color: white" closeable close-icon="close">
      <van-row style="text-align: center;height: 50px;line-height: 50px; font-size: 15px;">
        <van-col span="24">{{ currName }}</van-col>
      </van-row>
      <div style="width: 100%;">
        <van-form v-if="datas && datas.length > 0" @submit="onSubmit(datas)">
          <base-cascader v-model="dept_id" :options="deptList" :required="true" label="指定分公司" />

          <van-field v-model="datas[0].name" :rules="[{ required: true, message: '请填写用户名' }]" name="用户名" label="企业名称" placeholder="用户名" />
          <van-field v-model="datas[0].corporation" :rules="[{ message: '请填写法定代表人' }]" name="法定代表人" label="法定代表人" placeholder="法定代表人" />
          <van-field v-model="datas[0].reg_date" label="成立日期" @focus="show3 = true" />
          <van-field v-model="datas[0].area" :rules="[{ required: true, message: '请填写地区' }]" label="地区" placeholder="地区" />
          <van-field v-model="datas[0].address" :rules="[{ required: true, message: '请填写办公地址' }]" label="办公地址" placeholder="办公地址" />
          <van-field v-model="datas[0].reg_address" label="注册地址" placeholder="注册地址" />
          <van-field v-model="datas[0].meet_address" :rules="[{ required: true, message: '请填写见面地址' }]" label="见面地址" placeholder="见面地址" />
          <base-search-select v-model="sell_emp_name" :url="'/employee/dict'" label="指定销售人员" @change="onEmpSelectChange" />
          <van-field v-model="datas[0].link_date" label="留电话时间" placeholder="留电话时间" @focus="show2 = true" />
          <van-field v-model="datas[0].linkman" :rules="[{ required: true, message: '请填写联系人' }]" label="联系人" placeholder="联系人" />
          <van-field v-model="datas[0].mobile":rules="[{ required: true, message: '请填写联系电话' }]" label="联系电话" placeholder="联系电话" />
          <van-field v-model="datas[0].email" label="邮箱" placeholder="邮箱" />

          <van-field v-model="clientName" style="position: relative;" label="签约客户" placeholder="签约客户" @keyup="client1(clientName, null)" />
          <van-list
            v-show="vanlist"
            v-model="loading"
            :finished="finished"
            style="position: absolute; top: 660px;left:90px; overflow: hidden; z-index:3005;  background-color: white;"
            finished-text="没有更多了"
          >
            <van-cell v-for="item in list1" :key="item.id" :title="item.name" style="cursor: pointer;" @click="onthis(item.id, item.name)" />
          </van-list>
          <van-radio-group v-model="is_distribution" direction="horizontal">
            <span style="font-size: 14px;color: #646566; margin: 10px 14px;">是否总部分配</span>
            <van-radio name="1">是</van-radio>
            <van-radio name="2">否</van-radio>
          </van-radio-group>
          <!-- <hr style="border: 1px solid red;width: 90%;"> -->
          <van-radio-group v-model="is_effective" direction="horizontal ">
            <span style="font-size: 14px;color: #646566; margin: 10px 14px;">资源是否有效</span>
            <van-radio name="1">是</van-radio>
            <van-radio name="2">否</van-radio>
          </van-radio-group>
          <van-field :value="value1" readonly clickable label="产品类型" placeholder="请选择产品类型" @click="showPicker = true" />
          <van-field :value="value2" readonly clickable label="服务" placeholder="请选择服务" @click="showPicker2 = true" />

          <div style="margin: 16px;"><van-button round block type="info" native-type="submit">提交</van-button></div>
        </van-form>
      </div>
    </van-popup>
    <van-popup v-model="show5" style="height: 50%;width: 90%; background-color: white" closeable close-icon="close">
      <van-row style="text-align: center;height: 50px;line-height: 50px; font-size: 15px;">
        <van-col span="24">{{ currName }}</van-col>
      </van-row>
      <div style="width: 100%;">
        <van-form ref="datas2" @submit="addOfflines(datas2)">
          <base-cascader v-model="dept_id2" :options="deptList2" :required="true" label="指定分公司" />

          <van-field v-model="datas2.name" :rules="[{ required: true, message: '请填写用户名' }]" name="用户名" label="企业名称" placeholder="用户名" />
          <van-field v-model="datas2.corporation" :rules="[{ message: '请填写法定代表人' }]" name="法定代表人" label="法定代表人" placeholder="法定代表人" />
          <van-field v-model="datas2.reg_date" label="成立日期" @focus="show3 = true" />
          <van-field v-model="datas2.area" :rules="[{ required: true, message: '请填写地区' }]" label="地区" placeholder="地区" />
          <van-field v-model="datas2.address" :rules="[{ required: true, message: '请填写办公地址' }]" label="办公地址" placeholder="办公地址" />
          <van-field v-model="datas2.reg_address" label="注册地址" placeholder="注册地址" />
          <van-field v-model="datas2.meet_address" :rules="[{ required: true, message: '请填写见面地址' }]" label="见面地址" placeholder="见面地址" />
          <base-search-select v-model="sell_emp_name" :url="'/employee/dict'" label="指定销售人员" @change="onEmpSelectChange" />
          <van-field v-model="datas2.link_date" label="留电话时间" placeholder="留电话时间" @focus="show2 = true" />
          <van-field v-model="datas2.linkman" :rules="[{ required: true, message: '请填写联系人' }]" label="联系人" placeholder="联系人" />
          <van-field v-model="datas2.mobile" :rules="[{ required: true, message: '请填写联系电话' }]" label="联系电话" placeholder="联系电话" />
          <van-field v-model="datas2.email" label="邮箱" placeholder="邮箱" />

          <van-field v-model="clientName" style="position: relative;" label="签约客户" placeholder="签约客户" @keyup="client1(clientName, null)" />
          <van-list
            v-show="vanlist"
            v-model="loading"
            :finished="finished"
            style="position: absolute; top: 660px; left:90px; overflow: hidden; z-index:3005;  background-color: white;"
            finished-text="没有更多了"
          >
            <van-cell v-for="item in list1" :key="item.id" :title="item.name" style="cursor: pointer;" @click="onthis(item.id, item.name)" />
          </van-list>
          <van-radio-group v-model="is_distribution" direction="horizontal">
            <span style="font-size: 14px;color: #646566; margin: 10px 14px;">是否总部分配</span>
            <van-radio name="1">是</van-radio>
            <van-radio name="2">否</van-radio>
          </van-radio-group>
          <!-- <hr style="border: 1px solid red;width: 90%;"> -->
          <van-radio-group v-model="is_effective" direction="horizontal ">
            <span style="font-size: 14px;color: #646566; margin: 10px 14px;">资源是否有效</span>
            <van-radio name="1">是</van-radio>
            <van-radio name="2">否</van-radio>
          </van-radio-group>
          <van-field :value="value1" readonly clickable label="产品类型" placeholder="请选择产品类型" @click="showPicker = true" />
          <van-field :value="value2" readonly clickable label="服务" placeholder="请选择服务" @click="showPicker2 = true" />

          <div style="margin: 16px;"><van-button round block type="info" native-type="submit">提交</van-button></div>
        </van-form>
      </div>
    </van-popup>

    <van-popup v-model="show3" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        type="date"
        title="选择年月日"
        @cancel="show3 = false"
        @confirm="birthdaychange(currentDate)"
      />
    </van-popup>
    <!--    <van-popup v-if="datas && datas.length > 0" v-model="show2" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker v-model="currentDate" :min-date="minDate" :max-date="maxDate" type="date" title="选择年月日" @cancel="show2 = false" @confirm="date(currentDate)" />
    </van-popup> -->
    <van-popup v-model="show2" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker v-model="currentDate" :min-date="minDate" :max-date="maxDate" type="date" title="选择年月日" @cancel="show2 = false" @confirm="date(currentDate)" />
    </van-popup>
    <van-popup v-model="showPicker" round position="bottom"><van-picker :columns="type" show-toolbar @cancel="showPicker = false" @confirm="onConfirm" /></van-popup>
    <van-popup v-model="showPicker2" round position="bottom"><van-picker :columns="value3" show-toolbar @cancel="showPicker2 = false" @confirm="onConfirm2" /></van-popup>
    <div>
      <van-tabbar safe-area-inset-bottom>
        <van-pagination v-model="queryCondition.page" :total-items="queryCondition.total" :show-page-size="4" force-ellipses @change="query()" />
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { getResourceList } from '@/api/consult';
import { getSysDictionariesList, modifyOffline, addOffline } from '@/api/consult';
import { getClientDictList } from '@/api/client';
import { getProductList } from '@/api/product';
import { getDeptList } from '@/api/dept';
import { Dialog } from 'vant';
import { Toast } from 'vant';
export default {
  name: 'ResourceDevelopment',
  filters: {
    ellipsis(value) {
      if (!value) return '';
      if (value.length > 6) {
        return value.slice(0, 6) + '...';
      }
      return value;
    }
  },
  data() {
    return {

      option1: [
        { text: '全部商品', value: 0 },
        { text: '新款商品', value: 1 },
        { text: '活动商品', value: 2 }
      ],
      option2: [
        { text: '默认排序', value: 'a' },
        { text: '好评排序', value: 'b' },
        { text: '销量排序', value: 'c' }
      ],

      value4: '',
      dept_id: null,
      dept_id2: null,
      showPicker3: false,
      value1: '',
      showPicker: false,
      showPicker2: false,
      value2: '',
      value3: [],
      activeName: '',
      client_name: '',
      is_distribution: '1',
      is_effective: '1',
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2022, 10, 1),
      currentDate: new Date(),
      timeValue: '请选择时间',
      corporation: '',
      value: '',
      show3: false,
      show2: false,
      show: false,
      token1: null,
      show5: false,
      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',
        client_name: '',
        name: ''
      },
      sysdate: {
        page: 1,
        rows: 99999,
        status: 1
      },
      tip: this.CONST.EMPTY_MSG,
      data: [],
      datas: [],
      datas2: {
        id: '',
        client_name: '',
        dept_id: '',
        dept_name: '',
        address: '',
        area: '',
        name: '',
        corporation: '',
        reg_date: '',
        reg_address: '',
        meet_address: '',
        linkman: '',
        link_date: '',
        mobile: '',
        email: '',
        business_scope: '',
        comment: '',
        product_name: '',
        client_id: '',
        sell_emp_id: '',
        sell_emp_name: ''
      },
      currName: '',
      reg_date: '',
      list: [],
      list1: [],
      clientName: '',
      loading: false,
      finished: false,
      vanlist: false,
      type: [],
      product_type_id: '',
      product_type_name: '',
      product: {
        product_id: '',
        product_name: '',
        product_type_id: '',
        product_type_name: ''
      },
      deptList: [],
      deptList2: [],
      sell_emp_name: '',
      form: {
        consult_date: null,
        consult_curr_date: null,
        linkman: '',
        phone: '',
        source: null,
        status: null,
        is_important: 2,
        client_name: '',
        sex: 1,
        is_pri: 1,
        info: '',
        client_id: null,
        sys_client_name: '',
        product_type_id: null,
        product_id: null,
        productList: [],
        quote: '',
        dept_id: null,
        sell_emp_id: null,
        reg_address: '',
        busi_address: '',
        main_busi: '',
        is_imp_exp: 2,
        details: []
      }
    };
  },
  updated() {},
  mounted() {
    this.query();
    this.sys();
    this.produceList();
  },
  methods: {
    onEmpSelectChange(name, value) {
      if (value) {
        this.sell_emp_id = value.id;
        this.sell_emp_name = value.name;
      }
    },
    ins() {
      this.show5 = true;
      this.datas2 = {};
    },
    addOfflines(datas2) {
      const s = sessionStorage.getItem('dept').split('/');
      let dept_id = '';
      let dept_name = '';
      for (let i = 0; i < this.deptList2[0].children.length; i++) {
        for (let x = 0; x < this.deptList2[0].children[i].children.length; x++) {
          if (this.deptList2[0].children[i].children[x].label === s[s.length - 1]) {
            dept_name = this.deptList2[0].children[i].children[x].label;
            dept_id = this.deptList2[0].children[i].children[x].id;
          }
        }
      }
      const offline = {
        client_name: this.datas2.name,
        dept_id: parseInt(dept_id),
        dept_name: dept_name,
        address: this.datas2.address,
        area: this.datas2.area,
        is_distribution: parseInt(this.is_distribution),
        is_effective: parseInt(this.is_effective),
        name: this.datas2.name,
        corporation: this.datas2.corporation,
        reg_date: this.datas2.reg_date,
        reg_address: this.datas2.reg_address,
        meet_address: this.datas2.meet_address,
        linkman: this.datas2.linkman,
        link_date: this.datas2.link_date,
        mobile: this.datas2.mobile,
        email: this.datas2.email,
        business_scope: this.datas2.business_scope,
        comment: this.datas2.comment,
        product_name: this.datas2.product_name,
        client_id: parseInt(this.datas2.client_id),
        sell_emp_id: parseInt(this.sell_emp_id),
        sell_emp_name: this.sell_emp_name,
        product_id: parseInt(this.product.product_id),
        product_type_name: this.product.product_type_name,
        product_type_id: parseInt(this.product.product_type_id)
      };

      addOffline(offline).then(res => {
        if (res.success) {
          this.show5 = false;
          Toast.success(res.msg);
          this.query();
          this.sys();

          this.produceList();
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    onConfirm(value) {
      this.value1 = value;
      this.showPicker = false;
      this.produceList(value, null);
    },
    onConfirm2(value) {
      this.value2 = value;
      this.showPicker2 = false;
      this.produceList(null, value);
    },
    onthis(id, name) {
      if (this.datas.length > 0) {
        this.datas[0].client_id = id;
      } else {
        this.datas2.client_id = id;
      }

      this.clientName = name;
      this.vanlist = false;
      this.produceList();
    },
    produceList(value, value2) {
      const ax = {
        total: this.CONST.PAGINATION.TOTAL,
        page: 1,
        rows: 99999999,
        sort: 'id',
        order: 'desc',
        client_name: '',
        name: ''
      };
      this.queryCondition.rows = 99999999;
      this.queryCondition.name = '';
      this.product.product_name = '';
      this.product.product_type_name = '';
      this.product.product_id = '';
      this.product.product_type_id = '';
      getProductList(ax).then(res => {
        const i = res.rows.length;
        for (let a = 0; a < i; a++) {
          if (res.rows[a].type_name === value) {
            this.value3.push(res.rows[a].name);
          }
          if (res.rows[a].name === value2) {
            this.product.product_name += res.rows[a].name;
            this.product.product_type_name += res.rows[a].type_name;
            this.product.product_id += res.rows[a].id;
            this.product.product_type_id += res.rows[a].type_id;
          }
        }
      });
      getDeptList(this.queryCondition).then(res => {
        this.deptList = res.rows || [];
        this.deptList2 = res.rows || [];
      });
    },
    sys() {
      getSysDictionariesList(this.sysdate).then(res => {
        const len = res.rows.length;
        for (let i = 0; i < len; i++) {
          if (res.rows[i].comment === '产品类型') {
            this.type.push(res.rows[i].name);
          }
        }
      });
    },
    client1(value, value1) {
      this.list = [];
      this.list1 = [];
      if (this.clientName !== null && this.clientName.length !== 0) {
        this.ax();
      }
    },

    ax() {
      setTimeout(() => {
        this.queryCondition.name = this.clientName;
        getClientDictList(this.queryCondition).then(res => {
          const len = res.rows.length;
          if (len > 0) {
            this.vanlist = true;
          }
          for (let i = 0; i < len; i++) {
            this.list1.push({ id: res.rows[i].id, name: res.rows[i].name });
          }
          this.loading = false;
          // 数据全部加载完成
          if (this.list1.length >= len) {
            this.finished = true;
          }
        });
      }, 500);
    },
    date(val) {
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      if (this.datas.length > 0) {
        this.datas[0].link_date = `${year}-${month}-${day} `;
      }
      this.datas2.link_date = `${year}-${month}-${day} `;
      this.show2 = false;
    },
    birthdaychange(val) {
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      if (this.datas.length > 0) {
        this.datas[0].reg_date = `${year}-${month}-${day} `;
      }
      this.datas2.reg_date = `${year}-${month}-${day} `;
      this.show3 = false;
    },
    onSearch() {
      this.queryCondition.client_name = this.value;
      // this.data = [];
      this.query();
    },
    onSubmit(data) {
      const s = sessionStorage.getItem('dept').split('/');
      let dept_id = '';
      let dept_name = '';
      for (let i = 0; i < this.deptList[0].children.length; i++) {
        for (let x = 0; x < this.deptList[0].children[i].children.length; x++) {
          if (this.deptList[0].children[i].children[x].label === s[s.length - 1]) {
            dept_name = this.deptList[0].children[i].children[x].label;
            dept_id = this.deptList[0].children[i].children[x].id;
          }
        }
      }
      const offline = {
        id: this.datas[0].id,
        client_name: this.datas[0].name,
        dept_id: dept_id,
        dept_name: dept_name,
        address: this.datas[0].address,
        area: this.datas[0].area,
        name: this.datas[0].client_name,
        corporation: this.datas[0].corporation,
        reg_date: this.datas[0].reg_date,
        reg_address: this.datas[0].reg_address,
        meet_address: this.datas[0].meet_address,
        linkman: this.datas[0].linkman,
        link_date: this.datas[0].link_date,
        mobile: this.datas[0].mobile,
        email: this.datas[0].email,
        business_scope: this.datas[0].business_scope,
        comment: this.datas[0].comment,
        product_name: this.datas[0].product_name,
        client_id: this.datas[0].client_id,
        sell_emp_id: this.sell_emp_id,
        sell_emp_name: this.sell_emp_name,
        product_id: this.product.product_id,
        product_type_name: this.product.product_type_name,
        product_type_id: this.product.product_type_id,
        is_distribution: this.is_distribution,
        is_effective: this.is_effective
      };

      modifyOffline(offline).then(res => {
        if (res.success) {
          this.show = false;
          Toast.success(res.msg);
          this.query();
          this.sys();
          this.produceList();
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    query() {
      this.data = [];
      const ax = {
        total: this.queryCondition.total,
        page: this.queryCondition.page,
        rows: 10,
        sort: 'id',
        order: 'desc',
        client_name: this.queryCondition.client_name,
        name: ''
      };
      getResourceList(ax).then(res => {
        this.data = res.rows || [];
        this.queryCondition.total = res.total || 0;
      });
    },
    put(value) {
      this.show = true;
      this.datas = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id === value) {
          this.datas.push({
            id: this.data[i].id,
            name: this.data[i].client_name,
            corporation: this.data[i].corporation,
            reg_date: this.data[i].reg_date,
            area: this.data[i].area,
            address: this.data[i].address,
            reg_address: this.data[i].reg_address,
            meet_address: this.data[i].meet_address,
            linkman: this.data[i].linkman,
            link_date: this.data[i].link_date,
            mobile: this.data[i].mobile,
            email: this.data[i].email,
            business_scope: this.data[i].business_scope,
            comment: this.data[i].comment,
            dept_id: this.data[i].dept_id,
            dept_name: this.data[i].dept_name,
            product_name: this.data[i].product_name,
            client_id: this.data[i].client_ids
          });

          this.currName = this.data[i].name;
        }
      }
    },
    addr(val, val2) {
      Dialog.alert({
        title: val2,
        message: val,
        theme: 'round-button'
      }).then(() => {
        // on close
      });
    }
  }
};
</script>

<style scoped="scoped">
.van-tabbar--fixed >>> .van-pagination {
  margin: 0 auto;
}

.x {
  height: 25.6px;
  font-size: 12px;
  line-height: 25.6px;
}

</style>
<style>

 .van-dialog {
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/consult/resource-development.vue